(() => {
  const loaderKey = 'imageWithTextDeferredVideoLoader';

  if (window[loaderKey]) {
    window[loaderKey].init(document);
    return;
  }

  const selector = 'video[data-deferred-autoplay-video]';
  const observedVideos = new WeakSet();

  const loadPoster = (video) => {
    if (!video.dataset.poster) return;

    video.poster = video.dataset.poster;
    video.removeAttribute('data-poster');
  };

  const loadAndPlay = (video) => {
    loadPoster(video);

    if (video.dataset.videoLoaded !== 'true') {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.dataset.videoLoaded = 'true';
      video.autoplay = true;
      video.load();
    }

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  };

  const playbackObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                loadAndPlay(entry.target);
              } else if (entry.target.dataset.videoLoaded === 'true') {
                entry.target.pause();
              }
            });
          },
          { rootMargin: '0px' }
        )
      : null;

  const posterObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, currentObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              loadPoster(entry.target);
              currentObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  const init = (root) => {
    const videos = [];

    if (root instanceof Element && root.matches(selector)) videos.push(root);
    videos.push(...root.querySelectorAll(selector));

    videos.forEach((video) => {
      if (observedVideos.has(video)) return;

      observedVideos.add(video);
      if (playbackObserver && posterObserver) {
        posterObserver.observe(video);
        playbackObserver.observe(video);
      } else {
        loadAndPlay(video);
      }
    });
  };

  window[loaderKey] = { init };
  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
